import { RECIPE_ENDPOINTS } from "./endpoints";
import type { Recipe } from "./types";
import { apiGet } from "../shared";
import { extractRecipes, sanitizeDietTypes, sanitizeAllergens } from "./helpers";

function buildRecipesUrl(dietTypes: string[] = [], excludedAllergens: (string | number)[] = []): string {
  const params = new URLSearchParams();

  const validDietTypes = sanitizeDietTypes(dietTypes);
  const validAllergens = sanitizeAllergens(excludedAllergens);

  if (validDietTypes.length > 0) params.append("diets", validDietTypes.join(","));
  if (validAllergens.length > 0) params.append("excludedAllergens", validAllergens.join(","));

  return params.toString() ? `${RECIPE_ENDPOINTS.GET_ALL}?${params.toString()}` : RECIPE_ENDPOINTS.GET_ALL;
}

export default async function getAllRecipes(
  dietTypes: string[] = [],
  excludedAllergens: (string | number)[] = []
): Promise<Recipe[]> {
  const url = buildRecipesUrl(dietTypes, excludedAllergens);
  const response = await apiGet<{ data?: Recipe[] } | Recipe[]>(url);
  return extractRecipes(response);
}
